// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'processor-solid';

export const Component = () => (
  <path d='M20.595 8.813h3.927v-.958h-3.927V3.927h-3.928V0h-.958v3.927h-2.97V0h-.957v3.927h-2.97V0h-.957v3.927H3.927v3.928H0v.957h3.927v2.97H0v.958h3.927v2.97H0v.957h3.927v3.928h3.928v3.927h.957v-3.927h2.97v3.927h.958v-3.927h2.97v3.927h.957v-3.927h3.928v-3.928h3.927v-.958h-3.927v-2.97h3.927v-.957h-3.927v-2.97Z' />
);

export const viewBox = '0 0 25 25';
